import React, { Suspense, useEffect, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import GoogleAnalytics, { initGA } from './components/GoogleAnalytics';
import Loader from "./pages/sharedComponents/Loader";
import Layout from "./components/Layout.js";

const Home = lazy(() => import("./pages/Home/Home.js"));
const AboutUs = lazy(() => import("./pages/aboutUs/AboutUs"));
const Platform = lazy(() => import("./pages/platform/Platform.js"));
const Pricing = lazy(() => import("./pages/pricing_new/Pricingnew.js"));
const NotFound = lazy(() => import("./pages/notFound/NotFound.js")); 
const AppRoute = lazy(() => import("./pages/appRoute/AppRoute.js")); 
const ContactUs = lazy(() => import("./pages/contactUs/ContactUs.js")); 
const TermsAndConditions = lazy(() => import("./pages/termsAndConditions/TermsAndConditions.js")); 
const PrivacyPolicy = lazy(() => import("./pages/privacyPolicy/PrivacyPolicy.js")); 
const Faq = lazy(() => import("./pages/faq/Faq.js")); 

const SuspenseWrapper = ({ children }) => {
  return (
    <Suspense fallback={<Loader />}>
      {children}
    </Suspense>
  );
};

function App() {
  useEffect(() => {
    // Initialize Google Analytics when app loads
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <GoogleAnalytics />
        <Routes>
          <Route path="/" element={<SuspenseWrapper><Layout /></SuspenseWrapper>}>
            <Route index element={<Home />} /> 
            {/* <Route path="app" element={<Home />} />  */}
            {/* <Route path="Pricing" element={<Pricing />} />  */}
            <Route path="aboutus" element={<AboutUs />} /> 
            <Route path="platform" element={<Platform />} /> 
            <Route path="contactus" element={<ContactUs />} /> 
            <Route path="terms" element={<TermsAndConditions />} /> 
            <Route path="privacy" element={<PrivacyPolicy />} /> 
            {/* Legacy legal URLs -> new short public URLs */}
            <Route path="termsAndConditions" element={<Navigate to="/terms" replace />} /> 
            <Route path="privacyPolicy" element={<Navigate to="/privacy" replace />} /> 
            {/* <Route path="faq" element={<Faq />} />  */}
            <Route path="*" element={<SuspenseWrapper><Home /></SuspenseWrapper>} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
